import "core-js/modules/es6.function.name";
import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import _merge from "lodash/merge";
import { SplitFactory } from '@splitsoftware/splitio';
import { Logger } from './logger';
import { AbstractFeatureLoader } from './AbstractFeatureLoader';
// auth key is okay to be defined here as it is a browser key
var API_KEY_BROWSER_STAGING = '9tki9945f3cm990tv5b202rt5tg3scs7qshl';
var API_KEY_BROWSER_PRODUCTION = 'llg5pt0eciq2hv42p33c1d1kfi0qff50dofp';
var API_KEY_BROWSER_TEST = 'k414ua4q9kgp2592q33obkasit0cmdju060d';
var API_KEY_BROWSER_DEV = 'jbkf81qu9keu11hc55u5go6fo291cmqce6gj';

function getDefaultOptions(environment) {
  var base = {
    core: {
      authorizationKey: '',
      key: 'originCustomer',
      trafficType: 'customer'
    },
    startup: {
      readyTimeout: 60,
      requestTimeoutBeforeReady: 60,
      retriesOnFailureBeforeReady: 3
    },
    scheduler: {
      featuresRefreshRate: 60,
      segmentsRefreshRate: 3600
    }
  };

  switch (environment) {
    case 'dev':
      base.core.authorizationKey = API_KEY_BROWSER_DEV;
      break;

    case 'test':
      base.core.authorizationKey = API_KEY_BROWSER_TEST;
      break;

    case 'staging':
      base.core.authorizationKey = API_KEY_BROWSER_STAGING;
      break;

    case 'prod':
      base.core.authorizationKey = API_KEY_BROWSER_PRODUCTION;
      base.scheduler.featuresRefreshRate = 600;
      base.scheduler.segmentsRefreshRate = 600;
      break;

    default:
      base.core.authorizationKey = API_KEY_BROWSER_STAGING;
  }

  return base;
}

export var SplitFeatureLoader =
/*#__PURE__*/
function (_AbstractFeatureLoade) {
  _inherits(SplitFeatureLoader, _AbstractFeatureLoade);

  function SplitFeatureLoader() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SplitFeatureLoader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SplitFeatureLoader).call(this));

    _defineProperty(_assertThisInitialized(_this), "sdk", void 0);

    _defineProperty(_assertThisInitialized(_this), "client", void 0);

    _defineProperty(_assertThisInitialized(_this), "manager", void 0);

    _defineProperty(_assertThisInitialized(_this), "isSetup", false);

    _defineProperty(_assertThisInitialized(_this), "isFailure", false);

    _defineProperty(_assertThisInitialized(_this), "logger", void 0);

    _defineProperty(_assertThisInitialized(_this), "defaultFeatureValue", void 0);

    _defineProperty(_assertThisInitialized(_this), "loader", void 0);

    var _options$loggingLevel = options.loggingLevel,
        loggingLevel = _options$loggingLevel === void 0 ? 'none' : _options$loggingLevel,
        onSetupComplete = options.onSetupComplete,
        onChange = options.onChange,
        onFailure = options.onFailure,
        factory = options.factory,
        _options$defaultFeatu = options.defaultFeatureValue,
        defaultFeatureValue = _options$defaultFeatu === void 0 ? false : _options$defaultFeatu,
        _options$environment = options.environment,
        environment = _options$environment === void 0 ? 'prod' : _options$environment,
        clientOptions = options.clientOptions,
        customerId = options.customerId;
    _this.logger = new Logger(loggingLevel);
    _this.defaultFeatureValue = defaultFeatureValue;
    var defaultSetupOptions = getDefaultOptions(environment);

    if (customerId) {
      defaultSetupOptions.core.key = customerId;
    }

    var splitSettings = _merge({}, defaultSetupOptions, clientOptions);

    _this.logger.debug('setting up split client with options', splitSettings);

    _this.sdk = factory ? factory(splitSettings) : SplitFactory(splitSettings);
    _this.client = _this.sdk.client();
    _this.manager = _this.sdk.manager();
    _this.loader = new _Promise(function (resolve) {
      _this.client.on(_this.client.Event.SDK_READY, function () {
        _this.isSetup = true;

        _this.logger.info('setup of split client complete');

        if (onSetupComplete) {
          onSetupComplete();
          resolve(true);
        }
      });
    });

    if (onChange) {
      _this.client.on(_this.client.Event.SDK_UPDATE, function () {
        _this.logger.info('features have been updated');

        onChange();
      });
    }

    _this.client.on(_this.client.Event.SDK_READY_TIMED_OUT, function () {
      _this.isFailure = true;
      var error = new Error('Failed to connect to split.io');

      _this.logger.error(error.message, error);

      onFailure && onFailure(error);
    });

    return _this;
  }

  _createClass(SplitFeatureLoader, [{
    key: "addFeatureListener",
    value: function addFeatureListener(listener) {
      var client = this.client;

      var changeListener = function changeListener() {
        listener();
      };

      client.on(client.Event.SDK_READY, changeListener);
      client.on(client.Event.SDK_UPDATE, changeListener);
      return {
        changeListener: changeListener
      };
    }
  }, {
    key: "addFailureListener",
    value: function addFailureListener(listener) {
      var client = this.client;

      var failureListener = function failureListener() {
        listener();
      };

      client.on(client.Event.SDK_READY_TIMED_OUT, failureListener);
      return {
        changeListener: failureListener
      };
    }
  }, {
    key: "removeFailureListener",
    value: function removeFailureListener(def) {
      var client = this.client;

      if (client) {
        client.off(client.Event.SDK_READY_TIMED_OUT, def.changeListener);
      }
    }
  }, {
    key: "removeFeatureListener",
    value: function removeFeatureListener(def) {
      var client = this.client;

      if (client) {
        client.off(client.Event.SDK_READY, def.changeListener);
        client.off(client.Event.SDK_UPDATE, def.changeListener);
      }
    }
  }, {
    key: "isFeatureEnabled",
    value: function isFeatureEnabled(name) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getFeature(name, context, options).enabled;
    }
  }, {
    key: "isTreatmentEnabled",
    value: function isTreatmentEnabled(treatment) {
      var defaultSwitchValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.defaultFeatureValue;

      if (treatment === 'control') {
        return defaultSwitchValue;
      }

      return treatment === 'on';
    }
  }, {
    key: "getFeature",
    value: function getFeature(name) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.logger.debug("getting feature ".concat(name, " with context ").concat(_JSON$stringify(context)));
      var defaultValue = options.defaultValue;
      var client = this.client;
      var treatment = client.getTreatment(name, context);
      var enabled = this.isTreatmentEnabled(treatment, defaultValue);
      return {
        name: name,
        enabled: enabled
      };
    }
  }, {
    key: "getFeatures",
    value: function getFeatures(names) {
      var _this2 = this;

      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return names.map(function (name) {
        return _this2.getFeature(name, context);
      });
    }
  }, {
    key: "getAllFeatures",
    value: function getAllFeatures() {
      var _this3 = this;

      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.manager.splits().map(function (splitView) {
        return _this3.getFeature(splitView.name, context, options);
      });
    }
  }]);

  return SplitFeatureLoader;
}(AbstractFeatureLoader);